import { GET_SWIMMING_DIFFICULTY_CATEGORY } from "../../types";

const initialState = {
  category: {},
};

export const swimmingDifficultyCategoryReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case GET_SWIMMING_DIFFICULTY_CATEGORY:
      return (() => ({
        ...state,
        category: action.data,
      }))();
    default:
      return state;
  }
};
